/** CoStar.Api.Localization.GeographyType */
export var GeographyType;
(function (GeographyType) {
    GeographyType[GeographyType["None"] = 0] = "None";
    GeographyType[GeographyType["City"] = 1] = "City";
    GeographyType[GeographyType["Subdivision"] = 2] = "Subdivision";
    GeographyType[GeographyType["Country"] = 3] = "Country";
    GeographyType[GeographyType["CoreBasedStatisticalArea"] = 4] = "CoreBasedStatisticalArea";
    GeographyType[GeographyType["ResearchMarket"] = 5] = "ResearchMarket";
    GeographyType[GeographyType["AssetClassMarket"] = 6] = "AssetClassMarket";
    GeographyType[GeographyType["CoStarMarket"] = 7] = "CoStarMarket";
    GeographyType[GeographyType["Continent"] = 8] = "Continent";
    GeographyType[GeographyType["Subcontinent"] = 9] = "Subcontinent";
})(GeographyType || (GeographyType = {}));
/** CoStar.Api.Localization.ResourceType */
export var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["None"] = 0] = "None";
    ResourceType[ResourceType["StoreTypeCategory"] = 1330203] = "StoreTypeCategory";
    ResourceType[ResourceType["AffordableRentSubtype"] = 1757726] = "AffordableRentSubtype";
    ResourceType[ResourceType["ConstructionStatus"] = 8074207] = "ConstructionStatus";
    ResourceType[ResourceType["PowerBrokerCoStarCampaign"] = 8972670] = "PowerBrokerCoStarCampaign";
    ResourceType[ResourceType["ExternalReferenceType"] = 9283275] = "ExternalReferenceType";
    ResourceType[ResourceType["RateEscalationType"] = 9422149] = "RateEscalationType";
    ResourceType[ResourceType["TenureType"] = 21672275] = "TenureType";
    ResourceType[ResourceType["MiscellaneousSpaceRateType"] = 27710963] = "MiscellaneousSpaceRateType";
    ResourceType[ResourceType["SaleCategory"] = 33509081] = "SaleCategory";
    ResourceType[ResourceType["AvailabilityType"] = 57850589] = "AvailabilityType";
    ResourceType[ResourceType["BuildOut"] = 58629014] = "BuildOut";
    ResourceType[ResourceType["UtilitySubtype"] = 59288498] = "UtilitySubtype";
    ResourceType[ResourceType["NeighborhoodPointOfInterestCategory"] = 64497134] = "NeighborhoodPointOfInterestCategory";
    ResourceType[ResourceType["SpaceUseName"] = 70247595] = "SpaceUseName";
    ResourceType[ResourceType["Amenity"] = 86581659] = "Amenity";
    ResourceType[ResourceType["HotelScale"] = 87241714] = "HotelScale";
    ResourceType[ResourceType["ApartmentMeteringType"] = 88038800] = "ApartmentMeteringType";
    ResourceType[ResourceType["RoomType"] = 100331594] = "RoomType";
    ResourceType[ResourceType["StreetSuffix"] = 105862924] = "StreetSuffix";
    ResourceType[ResourceType["ContactSpecialty"] = 112249002] = "ContactSpecialty";
    ResourceType[ResourceType["FloorSortOrder"] = 120636710] = "FloorSortOrder";
    ResourceType[ResourceType["BuildOutAllowance"] = 123819284] = "BuildOutAllowance";
    ResourceType[ResourceType["HotelTier"] = 146306274] = "HotelTier";
    ResourceType[ResourceType["FundStatus"] = 162581449] = "FundStatus";
    ResourceType[ResourceType["ApartmentRoofType"] = 175916382] = "ApartmentRoofType";
    ResourceType[ResourceType["OwnerType"] = 191058068] = "OwnerType";
    ResourceType[ResourceType["PropertyTypeFiltered"] = 199636519] = "PropertyTypeFiltered";
    ResourceType[ResourceType["DayOfWeekIso"] = 202413726] = "DayOfWeekIso";
    ResourceType[ResourceType["ParkingCategory"] = 213972133] = "ParkingCategory";
    ResourceType[ResourceType["OfficeType"] = 229206055] = "OfficeType";
    ResourceType[ResourceType["HotelOperationType"] = 242095636] = "HotelOperationType";
    ResourceType[ResourceType["LeaseDealSourceGroup"] = 250575351] = "LeaseDealSourceGroup";
    ResourceType[ResourceType["ApartmentRentType"] = 259748623] = "ApartmentRentType";
    ResourceType[ResourceType["LeaseTermType"] = 272574340] = "LeaseTermType";
    ResourceType[ResourceType["FloorAbbreviation"] = 280201753] = "FloorAbbreviation";
    ResourceType[ResourceType["LoanPaymentStatus"] = 281524338] = "LoanPaymentStatus";
    ResourceType[ResourceType["LeaseDealRentType"] = 294682321] = "LeaseDealRentType";
    ResourceType[ResourceType["TopographyType"] = 305744265] = "TopographyType";
    ResourceType[ResourceType["ApartmentFeeType"] = 312105625] = "ApartmentFeeType";
    ResourceType[ResourceType["FloorFormattedName"] = 312527335] = "FloorFormattedName";
    ResourceType[ResourceType["BreeamType"] = 327633727] = "BreeamType";
    ResourceType[ResourceType["FloorDescription"] = 335020217] = "FloorDescription";
    ResourceType[ResourceType["UtilityType"] = 335195018] = "UtilityType";
    ResourceType[ResourceType["ServiceTypeCategory"] = 337195946] = "ServiceTypeCategory";
    ResourceType[ResourceType["LeaseBreak"] = 354234817] = "LeaseBreak";
    ResourceType[ResourceType["TenantType"] = 356626147] = "TenantType";
    ResourceType[ResourceType["BuildOutConditionType"] = 358329145] = "BuildOutConditionType";
    ResourceType[ResourceType["LeaseDealConcessionType"] = 393823295] = "LeaseDealConcessionType";
    ResourceType[ResourceType["AmenityCategory"] = 398315448] = "AmenityCategory";
    ResourceType[ResourceType["SpaceUse"] = 416005859] = "SpaceUse";
    ResourceType[ResourceType["LeaseDealOriginType"] = 417803547] = "LeaseDealOriginType";
    ResourceType[ResourceType["MandateTypeDesc"] = 422927525] = "MandateTypeDesc";
    ResourceType[ResourceType["ContactRole"] = 426470028] = "ContactRole";
    ResourceType[ResourceType["BuildOutCondition"] = 436503491] = "BuildOutCondition";
    ResourceType[ResourceType["AttachmentTypeDescription"] = 437619292] = "AttachmentTypeDescription";
    ResourceType[ResourceType["ApartmentOwnershipType"] = 442888042] = "ApartmentOwnershipType";
    ResourceType[ResourceType["SpaceLayout"] = 452417182] = "SpaceLayout";
    ResourceType[ResourceType["OffsiteImprovementType"] = 472440541] = "OffsiteImprovementType";
    ResourceType[ResourceType["StreetDirection"] = 479723448] = "StreetDirection";
    ResourceType[ResourceType["LeaseDealType"] = 483821335] = "LeaseDealType";
    ResourceType[ResourceType["ApartmentStyleType"] = 491411461] = "ApartmentStyleType";
    ResourceType[ResourceType["PropertySubtype"] = 503406468] = "PropertySubtype";
    ResourceType[ResourceType["BelowMarketSaleReason"] = 504672813] = "BelowMarketSaleReason";
    ResourceType[ResourceType["PropertyLeedType"] = 507272161] = "PropertyLeedType";
    ResourceType[ResourceType["LoanType"] = 507994479] = "LoanType";
    ResourceType[ResourceType["SprinklerType"] = 508244922] = "SprinklerType";
    ResourceType[ResourceType["MonetaryUnit"] = 516727013] = "MonetaryUnit";
    ResourceType[ResourceType["PropertyFinancialAccountCategory"] = 520318432] = "PropertyFinancialAccountCategory";
    ResourceType[ResourceType["HotelConstructionProjectType"] = 528130738] = "HotelConstructionProjectType";
    ResourceType[ResourceType["PortfolioType"] = 540956649] = "PortfolioType";
    ResourceType[ResourceType["RentPlusType"] = 542769576] = "RentPlusType";
    /** @deprecated Please use PropertyGroupSubtype. */
    ResourceType[ResourceType["ShoppingCenterType"] = 544965218] = "ShoppingCenterType";
    ResourceType[ResourceType["IndustryName"] = 548427059] = "IndustryName";
    ResourceType[ResourceType["TenancyType"] = 550696960] = "TenancyType";
    ResourceType[ResourceType["OrgType"] = 555610696] = "OrgType";
    ResourceType[ResourceType["ContiguousSpaceType"] = 557214392] = "ContiguousSpaceType";
    ResourceType[ResourceType["FloodRisk"] = 565224253] = "FloodRisk";
    ResourceType[ResourceType["ServiceType"] = 571753118] = "ServiceType";
    ResourceType[ResourceType["RateBasis"] = 572392032] = "RateBasis";
    ResourceType[ResourceType["LeedType"] = 574178587] = "LeedType";
    ResourceType[ResourceType["SpaceType"] = 577534942] = "SpaceType";
    ResourceType[ResourceType["HotelRating"] = 578865277] = "HotelRating";
    ResourceType[ResourceType["LeaseDealEntitySourceType"] = 589382121] = "LeaseDealEntitySourceType";
    ResourceType[ResourceType["AmenityGroup"] = 589503376] = "AmenityGroup";
    ResourceType[ResourceType["HotelClass"] = 593490331] = "HotelClass";
    ResourceType[ResourceType["NaicsCode"] = 597932534] = "NaicsCode";
    ResourceType[ResourceType["SubmarketLocation"] = 598981065] = "SubmarketLocation";
    ResourceType[ResourceType["ResidentialParkingType"] = 600040500] = "ResidentialParkingType";
    ResourceType[ResourceType["StreetMapBook"] = 602612460] = "StreetMapBook";
    ResourceType[ResourceType["ListingType"] = 607330429] = "ListingType";
    ResourceType[ResourceType["ApartmentLifestyleSubType"] = 624859454] = "ApartmentLifestyleSubType";
    ResourceType[ResourceType["LoanSourceType"] = 645677237] = "LoanSourceType";
    ResourceType[ResourceType["HotelPriceRating"] = 648069739] = "HotelPriceRating";
    ResourceType[ResourceType["BuildingClass"] = 661600679] = "BuildingClass";
    ResourceType[ResourceType["SpaceUseCategory"] = 663591634] = "SpaceUseCategory";
    ResourceType[ResourceType["SalePriceStatus"] = 668003255] = "SalePriceStatus";
    ResourceType[ResourceType["CensusRegion"] = 668373889] = "CensusRegion";
    ResourceType[ResourceType["ContactLinkType"] = 668934977] = "ContactLinkType";
    ResourceType[ResourceType["UseClass"] = 671818020] = "UseClass";
    ResourceType[ResourceType["NaicsDescription"] = 681485031] = "NaicsDescription";
    ResourceType[ResourceType["StoreType"] = 686526524] = "StoreType";
    ResourceType[ResourceType["LeaseCompLeaseDealType"] = 687582495] = "LeaseCompLeaseDealType";
    ResourceType[ResourceType["FloodPlain"] = 688608647] = "FloodPlain";
    ResourceType[ResourceType["AutocompleteMatchType"] = 699914822] = "AutocompleteMatchType";
    ResourceType[ResourceType["EmployeeGrowthType"] = 700212987] = "EmployeeGrowthType";
    ResourceType[ResourceType["OwnerGroup"] = 706551647] = "OwnerGroup";
    ResourceType[ResourceType["ProposedLandUse"] = 709826883] = "ProposedLandUse";
    ResourceType[ResourceType["StreetType"] = 711823347] = "StreetType";
    ResourceType[ResourceType["LeaseDealStatus"] = 726397493] = "LeaseDealStatus";
    ResourceType[ResourceType["SaleCondition"] = 736736431] = "SaleCondition";
    ResourceType[ResourceType["ServiceTypeText"] = 739191821] = "ServiceTypeText";
    ResourceType[ResourceType["SpacePosition"] = 761254409] = "SpacePosition";
    ResourceType[ResourceType["GreenhouseGasCode"] = 771167393] = "GreenhouseGasCode";
    ResourceType[ResourceType["CreditRating"] = 788295697] = "CreditRating";
    ResourceType[ResourceType["PetType"] = 794666862] = "PetType";
    ResourceType[ResourceType["LeaseType"] = 830785787] = "LeaseType";
    ResourceType[ResourceType["RateEscalationAmountType"] = 834356192] = "RateEscalationAmountType";
    ResourceType[ResourceType["FloodZoneDescription"] = 846527379] = "FloodZoneDescription";
    ResourceType[ResourceType["OwnershipType"] = 847168200] = "OwnershipType";
    ResourceType[ResourceType["OnsiteImprovementType"] = 861221356] = "OnsiteImprovementType";
    ResourceType[ResourceType["CompStatusType"] = 869270324] = "CompStatusType";
    ResourceType[ResourceType["ContactExpertise"] = 875099484] = "ContactExpertise";
    ResourceType[ResourceType["LandType"] = 899625939] = "LandType";
    ResourceType[ResourceType["ResidentialSpecialtyType"] = 901274024] = "ResidentialSpecialtyType";
    ResourceType[ResourceType["ParkingType"] = 906523307] = "ParkingType";
    ResourceType[ResourceType["SaleStatus"] = 908762564] = "SaleStatus";
    ResourceType[ResourceType["LeaseDealSourceType"] = 910809983] = "LeaseDealSourceType";
    ResourceType[ResourceType["AuctionContactRole"] = 919785910] = "AuctionContactRole";
    ResourceType[ResourceType["ListingAmenity"] = 928820338] = "ListingAmenity";
    ResourceType[ResourceType["FundingRound"] = 938122580] = "FundingRound";
    ResourceType[ResourceType["AreaType"] = 938695936] = "AreaType";
    ResourceType[ResourceType["EnergyPerformanceConsumptionCode"] = 951438775] = "EnergyPerformanceConsumptionCode";
    ResourceType[ResourceType["Cuisine"] = 951820341] = "Cuisine";
    ResourceType[ResourceType["SicDescription"] = 955302064] = "SicDescription";
    /** @deprecated Use ListingPhoneCampaignCode. */
    ResourceType[ResourceType["ListingCampaignCode"] = 968803041] = "ListingCampaignCode";
    ResourceType[ResourceType["ListingPhoneCampaignCode"] = 968803041] = "ListingPhoneCampaignCode";
    ResourceType[ResourceType["PropertyStatus"] = 982648167] = "PropertyStatus";
    ResourceType[ResourceType["LoanPaymentFrequency"] = 983061142] = "LoanPaymentFrequency";
    ResourceType[ResourceType["BuildingConstructionMaterialType"] = 989636310] = "BuildingConstructionMaterialType";
    ResourceType[ResourceType["SidingType"] = 998767534] = "SidingType";
    ResourceType[ResourceType["OwnerSuperType"] = 1011552743] = "OwnerSuperType";
    ResourceType[ResourceType["EnergyPerformanceConsumption"] = 1036246185] = "EnergyPerformanceConsumption";
    ResourceType[ResourceType["OriginType"] = 1047938877] = "OriginType";
    ResourceType[ResourceType["PropertyGroupType"] = 1059176993] = "PropertyGroupType";
    ResourceType[ResourceType["ApartmentUtilityDescription"] = 1072547226] = "ApartmentUtilityDescription";
    ResourceType[ResourceType["ImpactAward"] = 1078613815] = "ImpactAward";
    ResourceType[ResourceType["SpecialOfferCategory"] = 1081414619] = "SpecialOfferCategory";
    ResourceType[ResourceType["HotelOperatingStatusReason"] = 1087217416] = "HotelOperatingStatusReason";
    ResourceType[ResourceType["AuctionMilestoneType"] = 1114831015] = "AuctionMilestoneType";
    ResourceType[ResourceType["DevelopmentApprovalType"] = 1154726053] = "DevelopmentApprovalType";
    ResourceType[ResourceType["Continent"] = 1163925526] = "Continent";
    ResourceType[ResourceType["OwnerTypeCategory"] = 1171551127] = "OwnerTypeCategory";
    ResourceType[ResourceType["LocationBusinessStatus"] = 1271756073] = "LocationBusinessStatus";
    ResourceType[ResourceType["ValueAddedTaxType"] = 1274698612] = "ValueAddedTaxType";
    ResourceType[ResourceType["PropertyFinancialAccount"] = 1280274629] = "PropertyFinancialAccount";
    ResourceType[ResourceType["Credentials"] = 1305374989] = "Credentials";
    ResourceType[ResourceType["HotelOperatingStatus"] = 1322279623] = "HotelOperatingStatus";
    ResourceType[ResourceType["HotelBrandConversionStatus"] = 1370399479] = "HotelBrandConversionStatus";
    ResourceType[ResourceType["HotelLocationType"] = 1393253274] = "HotelLocationType";
    ResourceType[ResourceType["CorridorType"] = 1428831119] = "CorridorType";
    ResourceType[ResourceType["ApartmentLifestyleType"] = 1432134603] = "ApartmentLifestyleType";
    ResourceType[ResourceType["AuctionMilestoneStatus"] = 1508530816] = "AuctionMilestoneStatus";
    ResourceType[ResourceType["SicCode"] = 1512197328] = "SicCode";
    ResourceType[ResourceType["MortgageClass"] = 1527954844] = "MortgageClass";
    ResourceType[ResourceType["LocationExpertise"] = 1579518705] = "LocationExpertise";
    ResourceType[ResourceType["BuildOutStatus"] = 1618740284] = "BuildOutStatus";
    ResourceType[ResourceType["BusinessSubType"] = 1627036701] = "BusinessSubType";
    ResourceType[ResourceType["VerificationSourceType"] = 1640886045] = "VerificationSourceType";
    ResourceType[ResourceType["GreenhouseGas"] = 1642296764] = "GreenhouseGas";
    ResourceType[ResourceType["SharingPermissionType"] = 1689393150] = "SharingPermissionType";
    ResourceType[ResourceType["RetailLocation"] = 1710398686] = "RetailLocation";
    ResourceType[ResourceType["AuctionStage"] = 1725323705] = "AuctionStage";
    ResourceType[ResourceType["FloodZone"] = 1729829194] = "FloodZone";
    ResourceType[ResourceType["DataSourceType"] = 1734392747] = "DataSourceType";
    ResourceType[ResourceType["Language"] = 1739710771] = "Language";
    ResourceType[ResourceType["BusinessType"] = 1760915274] = "BusinessType";
    ResourceType[ResourceType["LocationType"] = 1766301410] = "LocationType";
    ResourceType[ResourceType["SaleType"] = 1774288256] = "SaleType";
    ResourceType[ResourceType["HotelRoomChangeType"] = 1791157377] = "HotelRoomChangeType";
    ResourceType[ResourceType["PriceRating"] = 1862752713] = "PriceRating";
    ResourceType[ResourceType["FundStructure"] = 1876934082] = "FundStructure";
    ResourceType[ResourceType["ConstructionEventType"] = 1899111941] = "ConstructionEventType";
    ResourceType[ResourceType["PropertyGroupSubtype"] = 1902349453] = "PropertyGroupSubtype";
    ResourceType[ResourceType["FundStrategy"] = 1903883947] = "FundStrategy";
    ResourceType[ResourceType["PowerBrokerCoStarAward"] = 1919913147] = "PowerBrokerCoStarAward";
    ResourceType[ResourceType["ProfessionalSpecialty"] = 1946792076] = "ProfessionalSpecialty";
    ResourceType[ResourceType["CostarMatchType"] = 1965323632] = "CostarMatchType";
    /** @deprecated This resource type will soon be deprecated. Please use HotelBrandConversionStatus instead. */
    ResourceType[ResourceType["BrandConversionStatus"] = 1975187019] = "BrandConversionStatus";
    ResourceType[ResourceType["AuctionStageStatus"] = 1976196168] = "AuctionStageStatus";
    ResourceType[ResourceType["ContactAffiliationType"] = 1980662859] = "ContactAffiliationType";
    ResourceType[ResourceType["CoStarBldgType"] = 2029236471] = "CoStarBldgType";
    ResourceType[ResourceType["LoanAccrualMethod"] = 2036309731] = "LoanAccrualMethod";
    ResourceType[ResourceType["PropertyType"] = 2043476447] = "PropertyType";
    ResourceType[ResourceType["AttachmentSource"] = 2103518503] = "AttachmentSource";
    ResourceType[ResourceType["SpaceUseCategoryName"] = 2104436923] = "SpaceUseCategoryName";
    ResourceType[ResourceType["SubContinent"] = 2107217915] = "SubContinent";
    ResourceType[ResourceType["Expertise"] = 2124737659] = "Expertise";
    ResourceType[ResourceType["HotelResortType"] = 2134366570] = "HotelResortType";
    ResourceType[ResourceType["ListingStatus"] = 2146276178] = "ListingStatus";
})(ResourceType || (ResourceType = {}));
/** CoStar.Api.Localization.MarketingBrand */
export var MarketingBrand;
(function (MarketingBrand) {
    MarketingBrand[MarketingBrand["Generic"] = 0] = "Generic";
    MarketingBrand[MarketingBrand["ApartmentsCom"] = 1] = "ApartmentsCom";
    MarketingBrand[MarketingBrand["ApartmentFinder"] = 2] = "ApartmentFinder";
    MarketingBrand[MarketingBrand["ApartmentHomeLiving"] = 3] = "ApartmentHomeLiving";
    MarketingBrand[MarketingBrand["FinderSites"] = 4] = "FinderSites";
    MarketingBrand[MarketingBrand["MoveSites"] = 5] = "MoveSites";
    MarketingBrand[MarketingBrand["LoopNet"] = 6] = "LoopNet";
    MarketingBrand[MarketingBrand["CityFeet"] = 7] = "CityFeet";
    MarketingBrand[MarketingBrand["Showcase"] = 8] = "Showcase";
    MarketingBrand[MarketingBrand["ForRent"] = 9] = "ForRent";
    MarketingBrand[MarketingBrand["ForRentUniversity"] = 10] = "ForRentUniversity";
    MarketingBrand[MarketingBrand["ForRentAfter55"] = 11] = "ForRentAfter55";
    MarketingBrand[MarketingBrand["ForRentCorporateHousing"] = 12] = "ForRentCorporateHousing";
    MarketingBrand[MarketingBrand["Realla"] = 13] = "Realla";
    MarketingBrand[MarketingBrand["WestSideRental"] = 15] = "WestSideRental";
})(MarketingBrand || (MarketingBrand = {}));
import { SubmarketPropertyType } from "../../../CoStar/Api/Autocomplete/ListingLocation/index.js";
/** CoStar.Api.Localization.SubmarketPropertyType */
export { SubmarketPropertyType };
/** CoStar.Api.Localization.Currency */
export var Currency;
(function (Currency) {
    Currency[Currency["None"] = 0] = "None";
    Currency[Currency["USDollar"] = 1] = "USDollar";
    Currency[Currency["CanadianDollar"] = 2] = "CanadianDollar";
    Currency[Currency["PoundSterling"] = 3] = "PoundSterling";
    Currency[Currency["Euro"] = 4] = "Euro";
    Currency[Currency["AustralianDollar"] = 5] = "AustralianDollar";
    Currency[Currency["BrazilianReal"] = 6] = "BrazilianReal";
    Currency[Currency["SwissFranc"] = 7] = "SwissFranc";
    Currency[Currency["JapaneseYen"] = 8] = "JapaneseYen";
    Currency[Currency["SingaporeDollar"] = 9] = "SingaporeDollar";
    Currency[Currency["HongKongDollar"] = 10] = "HongKongDollar";
    Currency[Currency["ChineseYuan"] = 11] = "ChineseYuan";
    Currency[Currency["UnitedArabEmiratesDirhams"] = 12] = "UnitedArabEmiratesDirhams";
    Currency[Currency["AfghanistanAfghani"] = 13] = "AfghanistanAfghani";
    Currency[Currency["AlbanianLeks"] = 14] = "AlbanianLeks";
    Currency[Currency["ArmenianDrams"] = 15] = "ArmenianDrams";
    Currency[Currency["NAGuilders"] = 16] = "NAGuilders";
    Currency[Currency["AngolanKwanzas"] = 17] = "AngolanKwanzas";
    Currency[Currency["ArgentinaPesos"] = 18] = "ArgentinaPesos";
    Currency[Currency["ArubanGuilder"] = 19] = "ArubanGuilder";
    Currency[Currency["AzerbaijanNewManat"] = 20] = "AzerbaijanNewManat";
    Currency[Currency["BHDinars"] = 21] = "BHDinars";
    Currency[Currency["BarbadosDollars"] = 22] = "BarbadosDollars";
    Currency[Currency["BangladeshTakas"] = 23] = "BangladeshTakas";
    Currency[Currency["BulgarianLev"] = 24] = "BulgarianLev";
    Currency[Currency["BurundiFrancs"] = 25] = "BurundiFrancs";
    Currency[Currency["BermudianDollars"] = 26] = "BermudianDollars";
    Currency[Currency["BruneiDollars"] = 27] = "BruneiDollars";
    Currency[Currency["Bolivianos"] = 28] = "Bolivianos";
    Currency[Currency["BahamianDollars"] = 29] = "BahamianDollars";
    Currency[Currency["Bitcoin"] = 30] = "Bitcoin";
    Currency[Currency["BotswanianPulas"] = 31] = "BotswanianPulas";
    Currency[Currency["BelarusianRuble"] = 32] = "BelarusianRuble";
    Currency[Currency["BelizeDollars"] = 33] = "BelizeDollars";
    Currency[Currency["CongoleseFranc"] = 34] = "CongoleseFranc";
    Currency[Currency["ChileanPesos"] = 35] = "ChileanPesos";
    Currency[Currency["ColombianPesos"] = 36] = "ColombianPesos";
    Currency[Currency["CostaRicanColons"] = 37] = "CostaRicanColons";
    Currency[Currency["CubanPesos"] = 38] = "CubanPesos";
    Currency[Currency["Escudos"] = 39] = "Escudos";
    Currency[Currency["CzechKoruna"] = 40] = "CzechKoruna";
    Currency[Currency["DjiboutiFrancs"] = 41] = "DjiboutiFrancs";
    Currency[Currency["DanishKrones"] = 42] = "DanishKrones";
    Currency[Currency["DominicanPesos"] = 43] = "DominicanPesos";
    Currency[Currency["AlgerianDinars"] = 44] = "AlgerianDinars";
    Currency[Currency["EgyptianPounds"] = 45] = "EgyptianPounds";
    Currency[Currency["EthiopianBirrs"] = 46] = "EthiopianBirrs";
    Currency[Currency["FijiDollars"] = 47] = "FijiDollars";
    Currency[Currency["GeorgianLari"] = 48] = "GeorgianLari";
    Currency[Currency["GhanaianNewCedi"] = 49] = "GhanaianNewCedi";
    Currency[Currency["Dalasi"] = 50] = "Dalasi";
    Currency[Currency["GuineanFranc"] = 51] = "GuineanFranc";
    Currency[Currency["GuatemalanQuetzals"] = 52] = "GuatemalanQuetzals";
    Currency[Currency["GuyanaDollars"] = 53] = "GuyanaDollars";
    Currency[Currency["HondurasLempira"] = 54] = "HondurasLempira";
    Currency[Currency["CroatianKunas"] = 55] = "CroatianKunas";
    Currency[Currency["Gourdes"] = 56] = "Gourdes";
    Currency[Currency["HungarianForint"] = 57] = "HungarianForint";
    Currency[Currency["IndonesianRupiah"] = 58] = "IndonesianRupiah";
    Currency[Currency["IsraeliShekel"] = 59] = "IsraeliShekel";
    Currency[Currency["IndianRupees"] = 60] = "IndianRupees";
    Currency[Currency["IraqiDinars"] = 61] = "IraqiDinars";
    Currency[Currency["Rials"] = 62] = "Rials";
    Currency[Currency["IcelandKronas"] = 63] = "IcelandKronas";
    Currency[Currency["JamaicanDollars"] = 64] = "JamaicanDollars";
    Currency[Currency["JordanDinars"] = 65] = "JordanDinars";
    Currency[Currency["KenyanShillings"] = 66] = "KenyanShillings";
    Currency[Currency["Soms"] = 67] = "Soms";
    Currency[Currency["CambodiaRiel"] = 68] = "CambodiaRiel";
    Currency[Currency["ComorosFrancs"] = 69] = "ComorosFrancs";
    Currency[Currency["SouthKoreanWon"] = 70] = "SouthKoreanWon";
    Currency[Currency["KuwaitiDinars"] = 71] = "KuwaitiDinars";
    Currency[Currency["CaymanIslandDollars"] = 72] = "CaymanIslandDollars";
    Currency[Currency["Tenges"] = 73] = "Tenges";
    Currency[Currency["NewKips"] = 74] = "NewKips";
    Currency[Currency["LebanesePounds"] = 75] = "LebanesePounds";
    Currency[Currency["SriLankanRupees"] = 76] = "SriLankanRupees";
    Currency[Currency["LiberianDollars"] = 77] = "LiberianDollars";
    Currency[Currency["Loti"] = 78] = "Loti";
    Currency[Currency["LibyanDinars"] = 79] = "LibyanDinars";
    Currency[Currency["MoroccanDirhams"] = 80] = "MoroccanDirhams";
    Currency[Currency["MoldovanLeu"] = 81] = "MoldovanLeu";
    Currency[Currency["MalagasyAriary"] = 82] = "MalagasyAriary";
    Currency[Currency["MyanmarKyats"] = 83] = "MyanmarKyats";
    Currency[Currency["MacauPatacas"] = 84] = "MacauPatacas";
    Currency[Currency["MauritanianQuguiya"] = 85] = "MauritanianQuguiya";
    Currency[Currency["MauritiusRupees"] = 86] = "MauritiusRupees";
    Currency[Currency["MaldivesRufiyaas"] = 87] = "MaldivesRufiyaas";
    Currency[Currency["Kwachas"] = 88] = "Kwachas";
    Currency[Currency["MexicanPesos"] = 89] = "MexicanPesos";
    Currency[Currency["MalaysianRinggit"] = 90] = "MalaysianRinggit";
    Currency[Currency["MozambiqueNewMetical"] = 91] = "MozambiqueNewMetical";
    Currency[Currency["NamibianDollars"] = 92] = "NamibianDollars";
    Currency[Currency["NigerianNairas"] = 93] = "NigerianNairas";
    Currency[Currency["NicaraguaCordobaOro"] = 94] = "NicaraguaCordobaOro";
    Currency[Currency["NorwegianKrones"] = 95] = "NorwegianKrones";
    Currency[Currency["NepalRupees"] = 96] = "NepalRupees";
    Currency[Currency["NewZealandDollar"] = 97] = "NewZealandDollar";
    Currency[Currency["OmaniRials"] = 98] = "OmaniRials";
    Currency[Currency["PanameanBalboas"] = 99] = "PanameanBalboas";
    Currency[Currency["PeruvianNewSol"] = 100] = "PeruvianNewSol";
    Currency[Currency["PapuaNewGuineaKinas"] = 101] = "PapuaNewGuineaKinas";
    Currency[Currency["PhilippinePesos"] = 102] = "PhilippinePesos";
    Currency[Currency["PakistaniRupees"] = 103] = "PakistaniRupees";
    Currency[Currency["PolishZloty"] = 104] = "PolishZloty";
    Currency[Currency["ParaguayanGuarani"] = 105] = "ParaguayanGuarani";
    Currency[Currency["QatarRiyals"] = 106] = "QatarRiyals";
    Currency[Currency["NewRomanianLeu"] = 107] = "NewRomanianLeu";
    Currency[Currency["SerbianDinar"] = 108] = "SerbianDinar";
    Currency[Currency["RussianRubles"] = 109] = "RussianRubles";
    Currency[Currency["RwandanFrancs"] = 110] = "RwandanFrancs";
    Currency[Currency["SaudiRiyals"] = 111] = "SaudiRiyals";
    Currency[Currency["SolomonIslandsDollars"] = 112] = "SolomonIslandsDollars";
    Currency[Currency["SeychellesRupees"] = 113] = "SeychellesRupees";
    Currency[Currency["SudanesePound"] = 114] = "SudanesePound";
    Currency[Currency["SwedishKronas"] = 115] = "SwedishKronas";
    Currency[Currency["Leones"] = 116] = "Leones";
    Currency[Currency["SomaliShillings"] = 117] = "SomaliShillings";
    Currency[Currency["SurinameDollar"] = 118] = "SurinameDollar";
    Currency[Currency["SaoTomePrincipeDobra"] = 119] = "SaoTomePrincipeDobra";
    Currency[Currency["ElSalvadorColon"] = 120] = "ElSalvadorColon";
    Currency[Currency["Lilangeni"] = 121] = "Lilangeni";
    Currency[Currency["ThailandBaht"] = 122] = "ThailandBaht";
    Currency[Currency["TajikistanSomoni"] = 123] = "TajikistanSomoni";
    Currency[Currency["TurkmenNewManat"] = 124] = "TurkmenNewManat";
    Currency[Currency["TunisianDinars"] = 125] = "TunisianDinars";
    Currency[Currency["PaAngas"] = 126] = "PaAngas";
    Currency[Currency["TurkishLiras"] = 127] = "TurkishLiras";
    Currency[Currency["TrinidadTobagoDollars"] = 128] = "TrinidadTobagoDollars";
    Currency[Currency["TaiwanDollar"] = 129] = "TaiwanDollar";
    Currency[Currency["TanzanianShillings"] = 130] = "TanzanianShillings";
    Currency[Currency["UkrainianHryvnia"] = 131] = "UkrainianHryvnia";
    Currency[Currency["UgandanShillings"] = 132] = "UgandanShillings";
    Currency[Currency["UruguayPeso"] = 133] = "UruguayPeso";
    Currency[Currency["Som"] = 134] = "Som";
    Currency[Currency["VenezuelanBolivarSoberano"] = 135] = "VenezuelanBolivarSoberano";
    Currency[Currency["VietnameseNewDongs"] = 136] = "VietnameseNewDongs";
    Currency[Currency["CFAFrancs"] = 137] = "CFAFrancs";
    Currency[Currency["EastCaribbeanDollars"] = 138] = "EastCaribbeanDollars";
    Currency[Currency["CentralAfricanFrancs"] = 139] = "CentralAfricanFrancs";
    Currency[Currency["FrenchPacificIslandsFranc"] = 140] = "FrenchPacificIslandsFranc";
    Currency[Currency["YemenRials"] = 141] = "YemenRials";
    Currency[Currency["SouthAfricanRands"] = 142] = "SouthAfricanRands";
    Currency[Currency["ZambianKwacha"] = 143] = "ZambianKwacha";
    Currency[Currency["BahrainiDinars"] = 144] = "BahrainiDinars";
    Currency[Currency["EritreanNakfa"] = 145] = "EritreanNakfa";
    Currency[Currency["FalklandIslandsPound"] = 146] = "FalklandIslandsPound";
    Currency[Currency["GibraltarPounds"] = 147] = "GibraltarPounds";
    Currency[Currency["NorthKoreanWon"] = 148] = "NorthKoreanWon";
    Currency[Currency["Tugriks"] = 149] = "Tugriks";
    Currency[Currency["Pounds"] = 150] = "Pounds";
    Currency[Currency["SyrianPounds"] = 151] = "SyrianPounds";
    Currency[Currency["VanuatuVatu"] = 152] = "VanuatuVatu";
    Currency[Currency["Zimbabweandollar"] = 153] = "Zimbabweandollar";
    Currency[Currency["SamoanTala"] = 154] = "SamoanTala";
    Currency[Currency["BhutaneseNgultrum"] = 155] = "BhutaneseNgultrum";
    Currency[Currency["MacedonianDenar"] = 156] = "MacedonianDenar";
})(Currency || (Currency = {}));
/** CoStar.Api.Localization.TranslationStatus */
export var TranslationStatus;
(function (TranslationStatus) {
    TranslationStatus[TranslationStatus["None"] = 0] = "None";
    TranslationStatus[TranslationStatus["BrandMatch"] = 1] = "BrandMatch";
    TranslationStatus[TranslationStatus["ScriptMatch"] = 2] = "ScriptMatch";
    TranslationStatus[TranslationStatus["LanguageMatch"] = 4] = "LanguageMatch";
    TranslationStatus[TranslationStatus["CultureMatch"] = 8] = "CultureMatch";
})(TranslationStatus || (TranslationStatus = {}));
/** CoStar.Api.Localization.SpaceUseBitmap */
export var SpaceUseBitmap;
(function (SpaceUseBitmap) {
    SpaceUseBitmap[SpaceUseBitmap["None"] = 0] = "None";
    SpaceUseBitmap[SpaceUseBitmap["Office"] = 1] = "Office";
    SpaceUseBitmap[SpaceUseBitmap["OfficeMedical"] = 2] = "OfficeMedical";
    SpaceUseBitmap[SpaceUseBitmap["OfficeRetail"] = 4] = "OfficeRetail";
    SpaceUseBitmap[SpaceUseBitmap["Medical"] = 8] = "Medical";
    SpaceUseBitmap[SpaceUseBitmap["Retail"] = 16] = "Retail";
    SpaceUseBitmap[SpaceUseBitmap["Flex"] = 32] = "Flex";
    SpaceUseBitmap[SpaceUseBitmap["Industrial"] = 64] = "Industrial";
})(SpaceUseBitmap || (SpaceUseBitmap = {}));
/** CoStar.Api.Localization.PropertyTypeBitmap */
export var PropertyTypeBitmap;
(function (PropertyTypeBitmap) {
    PropertyTypeBitmap[PropertyTypeBitmap["None"] = 0] = "None";
    PropertyTypeBitmap[PropertyTypeBitmap["Hospitality"] = 1] = "Hospitality";
    PropertyTypeBitmap[PropertyTypeBitmap["Industrial"] = 2] = "Industrial";
    PropertyTypeBitmap[PropertyTypeBitmap["Land"] = 4] = "Land";
    PropertyTypeBitmap[PropertyTypeBitmap["Office"] = 16] = "Office";
    PropertyTypeBitmap[PropertyTypeBitmap["GeneralRetail"] = 32] = "GeneralRetail";
    PropertyTypeBitmap[PropertyTypeBitmap["Flex"] = 64] = "Flex";
    PropertyTypeBitmap[PropertyTypeBitmap["SportsEntertainment"] = 128] = "SportsEntertainment";
    PropertyTypeBitmap[PropertyTypeBitmap["MixedUse"] = 256] = "MixedUse";
    PropertyTypeBitmap[PropertyTypeBitmap["Specialty"] = 512] = "Specialty";
    PropertyTypeBitmap[PropertyTypeBitmap["Multifamily"] = 1024] = "Multifamily";
    PropertyTypeBitmap[PropertyTypeBitmap["Healthcare"] = 4096] = "Healthcare";
    PropertyTypeBitmap[PropertyTypeBitmap["Unknown"] = 8192] = "Unknown";
    PropertyTypeBitmap[PropertyTypeBitmap["Residential"] = 16384] = "Residential";
    PropertyTypeBitmap[PropertyTypeBitmap["Student"] = 1073741824] = "Student";
})(PropertyTypeBitmap || (PropertyTypeBitmap = {}));
